var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HelpBox',[_c('IxRes',{attrs:{"context":{schema: _vm.metaData.$schema}}},[_vm._v("frs.mapManagement.unsupportedMetaData")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }